export default {
  userDetailSections: [
    {
      name: 'About You',
      routeName: 'job-application-profile/about-you',
      propsToCheck: ['personal.maritalStatus', 'personal.drivingLicenseFull'],
    },
    {
      name: 'Address History',
      routeName: 'job-application-profile/address-history',
      propsToCheck: ['addresses'],
    },
    {
      name: 'Employment History',
      routeName: 'job-application-profile/employment-history',
      propsToCheck: ['employmentHistory'],
    },
    // Hidden at Jason's request CC-455
    // {
    //   name: 'Experience',
    //   routeName: 'job-application-profile/experience',
    //   propsToCheck: [
    //     'experience.olderPeople',
    //     'experience.dementia',
    //     'experience.learningDisabilities',
    //     'experience.mentalDisorder',
    //     'experience.terminallyIll',
    //     'experience.deceased',
    //     'experience.supportingCommunity',
    //     'experience.money',
    //     'experience.moving',
    //     'experience.hoist',
    //     'experience.walkingAids',
    //     'experience.transferAids',
    //     'experience.wheelchair',
    //     'experience.transfer',
    //     'experience.foodAndDrink',
    //     'experience.foodHygiene',
    //     'experience.mealPrep',
    //     'experience.nutrition',
    //     'experience.toileting',
    //     'experience.catheter',
    //     'experience.commodes',
    //     'experience.healthAndSafety',
    //     'experience.riskAsseessments',
    //     'experience.COSHH',
    //     'experience.infectionControl',
    //     'experience.dutyOfCare',
    //     'experience.diversity',
    //     'experience.personCentredCare',
    //     'experience.safeguarding',
    //     'experience.firstAid',
    //     'experience.information',
    //     'experience.domestic',
    //     'experience.laundry',
    //     'experience.bedMaking',
    //     'experience.ironing',
    //     'experience.personalTasks',
    //     'experience.washing',
    //     'experience.bathing',
    //     'experience.shaving',
    //     'experience.teeth',
    //     'experience.hair',
    //     'experience.puttingToBed',
    //   ],
    // },
    {
      name: 'Qualifications',
      routeName: 'job-application-profile/qualifications',
      propsToCheck: ['qualifications'],
    },
    {
      name: 'References',
      routeName: 'job-application-profile/references',
      propsToCheck: ['personalReferences'],
    },
    /*
    {
      name: 'DBS',
      routeName: 'job-application-profile/dbs',
      propsToCheck: [],
    },
    {
      name: 'Personal Statement',
      routeName: 'job-application-profile/personal-statement',
      propsToCheck: [],
    },
    */
  ],
  defaultUserDetails: {
    bookmarkedJobOpportunities: [],
    personal: {
      maritalStatus: '',
      religion: '',
      ethnicOrigin: '',
      drivingLicenseFull: null,
      drivingLicenseFullLengthYears: 0,
      drivingConvictions: null,
    },
    workPrefs: {
      hoursPerWeek: 0,
      canWorkWeekends: null,
      availableWorkPatterns: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
    },
    addresses: [],
    employmentHistory: [],
    qualifications: { noQualifications: false, qualifications: [] },
    experience: {},
    personalReferences: [],
  },
  maritalStatus: [
    'single',
    'married',
    'registered partnership',
    'divorced',
    'separated',
    'widowed',
  ],
  blankAddress: {
    line1: '',
    line2: '',
    line3: '',
    city: '',
    county: '',
    country: 'GB',
    postCode: '',
    movedInDateMonth: null,
    movedInDateYear: null,
    movedOutDateMonth: null,
    movedOutDateYear: null,
    currentAddress: false,
  },
  blankEmployment: {
    employmentStatus: null,
    organisationName: '',
    positionHeld: '',
    description: '',
    startDateMonth: null,
    startDateYear: null,
    endDateMonth: null,
    endDateYear: null,
    reference: {
      contactName: '',
      contactJobTitle: '',
      contactEmail: '',
      contactPhone: '',
      notes: '',
    },
  },
  employmentStatus: [
    'employed',
    'self-employed',
    'education',
    'out of work',
    'volunteer',
    'other',
  ],
  blankQualifications: {
    noQualifications: null,
    qualifications: [],
  },
  blankQualification: {
    name: '',
    completedMonth: null,
    completedYear: null,
    level: '',
  },
  blankReference: {
    contactName: '',
    contactJobTitle: '',
    contactEmail: '',
    contactPhone: '',
    notes: '',
  },
  yearsKnown: [
    { value: 0, text: 'Less than 1 year' },
    { value: 1, text: '1 year' },
    { value: 2, text: '2 years' },
    { value: 3, text: '3 years' },
    { value: 4, text: '4 years' },
    { value: 5, text: '5 years' },
    { value: 6, text: '6 years' },
    { value: 7, text: '7 years' },
    { value: 8, text: '8 years' },
    { value: 9, text: '9 years' },
    { value: 10, text: '10 years' },
    { value: 11, text: 'More than 10 years' },
  ],
  blankBasicProfile: {
    email: '',
    phone: '',
    prefs: {
      receiveJobAlerts: false,
      receiveSmsNotificationForEmails: true,
      consentToDirectContactAboutJobs: null,
    },
    jobInterests: {
      types: [],
      jobOpportunityRef: '',
    },
    profile: {
      title: '',
      firstName: '',
      lastName: '',
      otherNames: '',
    },
    signup: {
      howDidYouHearAboutUs: '',
    },
  },
  jobTypes: [
    'Chef / Cook',
    'Maintenance',
    'Support Worker',
    'Manager',
    'Laundry / Cleaning',
    'Admin',
    'Health Care Assistant',
  ],
  requiredFields: [
    'phone',
    'email',
    'profile.firstName',
    'profile.lastName',
    'prefs.consentToDirectContactAboutJobs',
  ],
};
